/**
 * TanStack Query hooks for `outbrain-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	outbrainIntegrationQueryKeys,
	type CreateOutbrainIntegrationBody,
	type ListOutbrainIntegrationResponse,
	type OutbrainIntegrationRow,
} from "./api";

export function useOutbrainIntegrationList(): UseQueryResult<ListOutbrainIntegrationResponse, Error> {
	return useQuery({
		queryKey: outbrainIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useOutbrainIntegrationCreate(): UseMutationResult<OutbrainIntegrationRow, Error, CreateOutbrainIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: outbrainIntegrationQueryKeys.all });
		},
	});
}

export function useOutbrainIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: outbrainIntegrationQueryKeys.all });
		},
	});
}
